import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Products
export const getProducts = async (filters = {}) => {
  const params = new URLSearchParams(filters).toString();
  const url = params ? `${API}/products?${params}` : `${API}/products`;
  const response = await axios.get(url);
  return response.data;
};

export const getProduct = async (id) => {
  const response = await axios.get(`${API}/products/${id}`);
  return response.data;
};

export const createProduct = async (productData) => {
  const response = await axios.post(`${API}/products`, productData, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const updateProduct = async (id, productData) => {
  const response = await axios.put(`${API}/products/${id}`, productData, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const deleteProduct = async (id) => {
  const response = await axios.delete(`${API}/products/${id}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Orders
export const createOrder = async (orderData) => {
  const response = await axios.post(`${API}/orders`, orderData, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const getOrders = async () => {
  const response = await axios.get(`${API}/orders`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const getOrder = async (id) => {
  const response = await axios.get(`${API}/orders/${id}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const updateOrderStatus = async (id, status) => {
  const response = await axios.put(`${API}/orders/${id}/status?status=${status}`, {}, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Invoices
export const getInvoices = async () => {
  const response = await axios.get(`${API}/invoices`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const getInvoice = async (id) => {
  const response = await axios.get(`${API}/invoices/${id}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const updateInvoiceStatus = async (id, status) => {
  const response = await axios.put(`${API}/invoices/${id}/status?status=${status}`, {}, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Contact
export const submitContactInquiry = async (inquiryData) => {
  const response = await axios.post(`${API}/contact`, inquiryData);
  return response.data;
};

export const getContactInquiries = async () => {
  const response = await axios.get(`${API}/contact`, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Admin
export const getClients = async () => {
  const response = await axios.get(`${API}/admin/clients`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const getAdminStats = async () => {
  const response = await axios.get(`${API}/admin/stats`, {
    headers: getAuthHeader()
  });
  return response.data;
};
